'use client';

import Link from 'next/link';
import { useT } from '@/lib/i18n';

/**
 * Custom 404. Per Next.js 16 conventions, the root `not-found.tsx` is rendered
 * for both explicit `notFound()` calls AND any unmatched URL across the app.
 *
 * Marked 'use client' so we can read the active i18n locale via `useT()`.
 * Next.js automatically injects `<meta name="robots" content="noindex" />`
 * for 404 responses, so no manual robots metadata needed here.
 */
export default function NotFound() {
  const t = useT();
  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'grid',
        placeItems: 'center',
        padding: '40px 20px',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: 480 }}>
        <div
          style={{
            fontFamily: 'var(--font-headline)',
            fontSize: 88,
            fontWeight: 600,
            lineHeight: 1,
            color: 'var(--ink-3)',
            marginBottom: 8,
          }}
        >
          404
        </div>
        <h1
          style={{
            fontFamily: 'var(--font-headline)',
            fontSize: 32,
            margin: '0 0 12px',
          }}
        >
          {t('errors.not_found_title')}
        </h1>
        <p style={{ color: 'var(--ink-2)', marginBottom: 24, lineHeight: 1.6 }}>
          {t('errors.not_found_body')}
        </p>
        <Link href="/" className="ps-btn ps-btn-primary no-underline">
          <span className="material-symbols-outlined ps-icon">home</span>
          {t('legal.back_home')}
        </Link>
      </div>
    </div>
  );
}
